import rrwebPlayer from "rrweb-player";
import "rrweb-player/dist/style.css";

type WindowWithRRPlayer = typeof window & {
  rrwebPlayer: typeof rrwebPlayer;
};

(window as WindowWithRRPlayer).rrwebPlayer = rrwebPlayer;
